/* Vault aesthetic — small UX helpers.
   Defensive: only runs if relevant elements exist. */
(function () {
  'use strict';

  // Color swatches: clicking one marks it active within its group.
  document.querySelectorAll('.vault-swatches').forEach(function (group) {
    var swatches = group.querySelectorAll('.vault-swatch');
    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        swatches.forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
      });
    });
  });

  // Optional: smooth-scroll for in-page anchor links.
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var hash = a.getAttribute('href');
      if (hash.length < 2) return;
      var target = document.querySelector(hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
